<template>
    <div>
        <div class="row">
            <div class="col">
                <h5 class="my-auto">
                    {{ wording[1].abstracttypepage.title }}
                </h5>
                <div v-html="wording[1].abstracttypepage.tilte_info"> </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <div class="alert alert-info mb-1">
                    <div class="row">
                        <div class="col-1 d-flex">
                            <icon :icon="['fad', 'exclamation']" class="my-auto fa-2x"/>
                        </div>
                        <div class="col" v-html="wording[1].abstracttypepage.tilte_help">

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-sm">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title text-success" style="text-align: center;" v-html="wording[1].abstracttypepage.type1"></h5>
                        <span v-html="wording[1].abstracttypepage.type1_info"></span>
                    </div>
                    <div class="card-footer bg-transparent border-0 d-flex">
                        <button class="btn btn-success mx-auto" v-on:click="newAbstract(1)">{{ wording[0].buttons.select }}</button>
                    </div>
                </div>
            </div>
            <div class="col-sm">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title text-success" style="text-align: center;" v-html="wording[1].abstracttypepage.type2"></h5>
                        <span v-html="wording[1].abstracttypepage.type2_info"></span>
                    </div>
                    <div class="card-footer bg-transparent border-0 d-flex">
                        <button class="btn btn-success mx-auto" v-on:click="newAbstract(2)">{{ wording[0].buttons.select }}</button>
                    </div>
                </div>
            </div>
            <div class="col-sm">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title text-success" style="text-align: center;" v-html="wording[1].abstracttypepage.type3"></h5>
                        <span v-html="wording[1].abstracttypepage.type3_info"></span>
                    </div>
                    <div class="card-footer bg-transparent border-0 d-flex">
                        <button class="btn btn-success mx-auto" v-on:click="newAbstract(3)">{{ wording[0].buttons.select }}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions} from 'vuex'

    export default {
        name: "AbstractType",
        data() {
            return {
                submitted: false,
            };
        },
        methods: {
            ...mapActions([
                'CREATE_ABSTRACT', 'UPDATE_REFERENCE'
            ]),
            newAbstract(type) {
                if (this.submitted === true) {
                    return false;
                }
                this.submitted = true;
                let template = {
                    "user_id": this.user.id,
                    "setting_submission_id": 1,
                    "reference_number": this.getSettings(1).reference_number,
                    "content": {'gesellschaft':type},
                    "status_id": 1
                };
                if(type === 2){
                    template.theme_id = 11;
                }
                if(type === 3){
                    template.theme_id = 12;
                }
              this.CREATE_ABSTRACT(template).then((response) => {
                this.$noty.success(this.wording[0].notify.save_success);
                this.$router.push('abstract/' + response.data.id + '/dynamic/' + this.getFirstCurrentPage(1).id)
              }).catch((error) => {
                this.$noty.error(this.wording[0].notify.save_not_success);
              });
            }
        },
        computed: {
            ...mapState([
                'wording', 'user'
            ]),
            ...mapGetters([
                'getSettings', 'getFirstCurrentPage'
            ]),
        },
    }
</script>

<style scoped>

</style>